<template>
  <div class="relative">
    <div class="vx-navbar-wrapper content-navbar"
         :class="[classObj, contentNavbarClass, navbarSticky ? 'bottom-border-radius-0' : '']">
      <vs-navbar
        class="vx-navbar navbar-custom navbar-skelton top-0 flex"
        :color="navbarColorLocal"
        :class="[textColor, !$vs.rtl ? 'rtl-only' : '']">

        <!--<vs-dropdown v-if="actions && actions.list">
          <a class="a-icon" href.prevent>
            <vs-icon icon-pack="feather" icon="icon-more-vertical"></vs-icon>
          </a>

          <vs-dropdown-menu class="navbar-more-actions">
            <vs-dropdown-item v-for="(item, index) in actions.list"
                              @click.stop="eventHandler(item.id, item.type)"
                              :class="[`useral-text-${item.color}`, 'px-2']"
                              :key="index"
                              divider>
              &lt;!&ndash;              <vs-icon icon="icon-check" icon-pack="feather"/>&ndash;&gt;
              {{ $t(item.i18n) }}
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>-->

        <div v-if="actions && getActionRightList.length > 0" class="relative">
          <custom-drop-down :list="getActionRightList"
                            :fix-to-right="$vs.rtl"
                            :default-show="actionsListStatus.right"
                            @closed="actionsListStatus.right = false"
                            @clicked="eventHandler($event.id, $event.type)">

            <template #button>
              <vs-icon @click="actionsListStatus.right = true"
                       class="useral-text-primary cursor-pointer"
                       icon-pack="feather"
                       icon="icon-more-vertical"/>
            </template>
          </custom-drop-down>
        </div>

        <div class="navbar-action-box" v-if="actions && getActionRightToolbar.length > 0">
          <p v-for="(item, index) in actions.toolbar"
             :key="`right-toolbar-${index}`"
             v-if="checkUserPermissions(item.permission)"
             @click.stop="eventHandler(item.id, item.type)"
             class="navbar-action"
             :class="[{[`action-button action-${item.color || 'primary'}`]: item.actionType === 'button'}, 'useral-font-weight-medium inline-block cursor-pointer', item.color ? `useral-text-${item.color}`: '']"
             style="vertical-align: middle;">

            <custom-icon v-if="item.icon && (item.iconPack === 'useral')"
                         :icon="item.icon"
                         icon-weight="solid"
                         :color="item.color"
                         :width="getIconSize"
                         :height="getIconSize"/>

            <vs-icon v-else-if="item.icon"
                     :icon="item.icon"
                     :icon-pack="item.iconPack"
                     :color="item.color ? item.color : ''"
                     :class="!item.color ? 'useral-text-primary' : ''"/>
            <span v-if="item.hasOwnProperty('badge') && item.badge.value > 0" class="badge"
                  :class="item.color ? `useral-color-${item.color}` : ''">
              {{ item.badge.value }}
            </span>
            {{ $t(item.i18n) }}
          </p>
        </div>

        <vs-spacer/>

        <p class="navbar-page-title useral-font-weight-bold text-lg" style="font-size: 16px">
          {{ $store.state.pageTitle || $t(route.meta.pageTitleI18n) || route.meta.pageTitle }}</p>

        <vs-spacer/>

        <!--<feather-icon v-if="$router.currentRoute.name !== 'home'"
                      @click.stop="$router.go(-1)"
                      icon="ChevronLeftIcon"/>-->

        <!--<p v-if="$router.currentRoute.name !== 'home'"
           @click.stop="$router.go(-1)"
           class="useral-font-weight-medium cursor-pointer px-2"
           style="font-size: 16px">{{ $t(`navbar.back`) }}</p>-->

        <div v-if="actions && getActionLeftList.length > 0" class="relative">
          <custom-drop-down :list="getActionLeftList"
                            :fix-to-right="!$vs.rtl"
                            :default-show="actionsListStatus.left"
                            @closed="actionsListStatus.left = false"
                            @clicked="eventHandler($event.id, $event.type)">

            <template #button>
              <vs-icon @click="actionsListStatus.left = true"
                       class="useral-text-primary cursor-pointer"
                       icon-pack="feather"
                       icon="icon-more-vertical"/>
            </template>
          </custom-drop-down>
        </div>

        <div class="navbar-action-box" v-if="actions && getActionLeftToolbar.length > 0">
          <p v-for="(item, index) in getActionLeftToolbar"
             :key="`left-toolbar-${index}`"
             v-if="checkUserPermissions(item.permission)"
             @click.stop="eventHandler(item.id, item.type)"
             class="navbar-action"
             :class="[{[`action-button action-${item.color || 'primary'}`]: item.actionType === 'button'}, 'useral-font-weight-medium inline-block cursor-pointer', item.color && item.actionType !== 'button' ? `useral-text-${item.color}`: '']"
             style="vertical-align: middle;">

            <custom-icon v-if="item.icon && (item.iconPack === 'useral')"
                         :icon="item.icon"
                         icon-weight="solid"
                         :color="item.icon === 'chevron-left-icon' ? 'dark-gray' : item.color"
                         :width="item.icon === 'chevron-left-icon' ? '20px' : getIconSize"
                         :height="item.icon === 'chevron-left-icon' ? '22px' : getIconSize"/>

            <vs-icon v-else-if="item.icon"
                     :icon="item.icon"
                     :icon-pack="item.iconPack"
                     :color="item.color ? item.color : ''"
                     :class="!item.color ? 'useral-text-primary' : ''"/>
            {{ $t(item.i18n) }}
          </p>
        </div>

      </vs-navbar>

      <button id="routeBackBTN" v-show="false" @click="handleGoToPrevRoute"></button>

<!--      <div class="bottom-shadow"></div>-->
    </div>
  </div>
</template>


<script>
import {mapGetters} from 'vuex'
import CustomDropDown from '@/components/dropDown/customDropDown'
import CustomIcon from '@/components/icon/customIcon'
import routeMixin from '../../../mixins/route'

export default {
  name: 'TheContentNavbar',
  components: {CustomIcon, CustomDropDown},
  mixins: [routeMixin],
  data () {
    return {
      route: {},
      actions: {},
      actionsListStatus: {
        right: false,
        left: false
      }
    }
  },
  props: {
    navbarColor: {
      type: String,
      default: '#fff'
    }
  },
  computed: {
    navbarColorLocal () {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#10163a' : this.navbarColor
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    contentNavbarStyle () {
      return this.$store.state.contentNavbarStyle
    },
    contentNavbarClass () {
      return this.$store.state.contentNavbarClass
    },
    textColor () {
      return {
        'text-white':
          (this.navbarColor !== '#10163a' &&
            this.$store.state.theme === 'dark') ||
          (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')
      }
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },

    // NAVBAR STYLE
    classObj () {
      if (this.verticalNavMenuWidth === 'default') return 'navbar-default'
      else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
      else if (this.verticalNavMenuWidth) return 'navbar-full'
    },

    navbarSticky () {
      return this.contentNavbarStyle === 'sticky'
    },

    getIconSize () {
      if (this.isMobile) {
        return '22px'
      } else {
        return '22px'
      }
    },

    getActionLeftList () {
      const list = this.actions.list || []
      if (this.isMobile) {
        if (this.actions.leftToolbar && this.actions.leftToolbar.filter(elm => elm.icon !== 'chevron-left-icon').length >= 2) {
          this.actions.leftToolbar.forEach((item) => {
            if (!(item.id === 'routeBackBTN' || (item.icon === 'chevron-left-icon' && item.type === 'link'))) {
              list.unshift(item)
            }
          })
        }
      }
      return list
    },

    getActionLeftToolbar () {
      let list = []
      if (this.isMobile) {
        if (this.actions.leftToolbar && this.actions.leftToolbar.filter(elm => elm.icon !== 'chevron-left-icon').length >= 2) {
          this.actions.leftToolbar.forEach((item) => {
            if (item.id === 'routeBackBTN' || (item.icon === 'chevron-left-icon' && item.type === 'link')) {
              list.unshift(item)
            }
          })
        } else {
          list = this.actions.leftToolbar || []
        }
      } else {
        list = JSON.parse(JSON.stringify(this.actions.leftToolbar || []))
        if (this.$route.meta.layoutStatus === 'profile') {
          const routeBackIndex = list.map(elm => elm.id).indexOf('routeBackBTN')
          if (routeBackIndex > -1) {
            list.splice(routeBackIndex, 1)
          }
        }
      }
      return list
    },

    getActionRightList () {
      const list = []
      if (this.isMobile) {
        if (this.actions.toolbar && this.actions.toolbar.length >= 2) {
          this.actions.toolbar.forEach((item) => {
            list.push(item)
          })
        }
      }
      return list
    },

    getActionRightToolbar () {
      let list = []
      if (this.isMobile) {
        if (this.actions.toolbar && this.actions.toolbar.length >= 2) {
        //
        } else {
          list = this.actions.toolbar || []
        }
      } else {
        list = JSON.parse(JSON.stringify(this.actions.toolbar || []))
      }
      return list
    },

    ...mapGetters(['navbarActions', 'isMobile'])
  },
  created () {
    this.route = this.$route
  },
  methods: {
    showSidebar () {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
    },
    eventHandler (value, type) {
      switch (type) {
      case 'link':
        this.$router.push(value)
        break

      case 'new-page-link':
        window.open(this.$router.resolve(value).href, '_blank')
        break

      case 'external-link':
        window.open(value, '_blank')
        break

      default:
        document.getElementById(`${value}`).click()
        break
      }
    },
    checkUserPermissions (permission) {
      return permission ? this.$u.checkPermissions(permission) : true
    },
    handleGoToPrevRoute () {
      const routeBackIndex = this.actions.leftToolbar.map(elm => elm.id).indexOf('routeBackBTN')
      if (routeBackIndex > -1) {
        this.customRouteBack(this.actions.leftToolbar[routeBackIndex].route)
      } else {
        this.customRouteBack()
      }
    }
  },
  watch: {
    '$route' () {
      this.$store.dispatch('updateNavbarActions', {})
      this.$store.dispatch('setPageTitle', '')
      this.route = this.$route
      this.actionsListStatus = {
        right: false,
        left: false
      }
    },
    '$store.state.navbarActions': {
      handler (val) {
        this.actions = val
      },
      deep: true
    },
    'navbarActions': {
      handler (val) {
        this.actions = val
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
@import "src/assets/scss/vuexy/variables";
.vx-navbar-wrapper.content-navbar {
  position: relative !important;
  width: 100%;
  height: fit-content !important;
  z-index: 9000;


  .bottom-shadow {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    height: 1px;
    //box-shadow: 0 0 10px 1px #cecece;
  }

  .vx-navbar {
    border-radius: .5rem .5rem 0 0;
    padding: 0.8rem !important;
    border-bottom: 1px solid #f0f0f0 !important;
    box-shadow: none;

    &.rtl-only {
      direction: rtl !important;
    }
  }

  &.bottom-border-radius-0 {
    border-radius: .5rem .5rem 0 0 !important;
    border-bottom: 1px solid #333333;
  }

  &.navbar-default {
    .vs-navbar {
      //width: calc(100% - 260px) !important;
    }
  }

  &.navbar-reduced {
    .vs-navbar {
      //width: calc(100% - 80px) !important;
    }
  }

  .vx-navbar {
    height: 50px;
    border-bottom: 1px solid #03092d;

    .navbar-page-title {
      display: block;
      width: calc(100% - 150px);
      position: absolute;
      right: 0;
      left: 0;
      text-align: center;
      margin: auto;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  i.vs-icon {
    font-size: 30px;

    @media (max-width: 576px) {
      font-size: 20px;
    }
  }

  .navbar-action-box {
    display: flex;
    align-items: center;
    gap: 13px;
  }

    .navbar-action {
      display: flex;
      align-items: center;
      position: relative;
      z-index: 1;

      .badge {
        position: absolute;
        top: -5px;
        right: -5px;
        color: #fff;
        background: $success;
        height: 20px;
        width: 20px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &.action-button {
        border-radius: 0.5rem;
        padding: 4px 8px !important;
        font-weight: 700 !important;
        color: #fff;

        &.action-danger {
          background-color: $danger;
        }

        &.action-success {
          background-color: $success;
        }

        &.action-warning {
          background-color: $warning;
        }

        &.action-primary {
          background-color: $primary;
        }
      }
    }
  }

  .md-max-w-half {
    width: 50%;
    min-width: 700px;

    @media screen and (max-width: 800px) {
      min-width: unset;
      width: 100%;
    }
  }
</style>

